import { render } from "./planWeek.vue?vue&type=template&id=fe6d6d6c&ts=true"
import script from "./planWeek.vue?vue&type=script&lang=ts"
export * from "./planWeek.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__